module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "foreword"
    }
  }, [_c('h1', [_vm._v("Foreword")]), _vm._v(" "), _c('p', [_vm._v("This mini book of unpoetry (yes, it’s a thing) tours the raggedy landscape of a mind carved out by anxiety and depression. It is about an earthly soul practically living in hell. It seeks to clarify the role religion plays as the oil in this ‘self-combustion’. More of a when-you-can’t-blame-anybody-else-blame-God monologue. Mental health is still a gloves-on issue—here the gloves are off.")]), _vm._v(" "), _c('p', [_c('em', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0